import { API_URL } from "../../constants/axios";
import { fetchApi } from "../fetch";

// 시도>시군구 지역 트리 (forecast_info 기반). 주소 선택/타겟팅 필터의 data 로 사용.
export const getRegionTree = async () => {
  const res = await fetchApi.get(API_URL.REGION_TREE);
  return res.data;
};

/**
 * 배송지 주소 필터용 시도>시군구 트리 (`zip_code` 기반).
 *
 * 🔴 `getRegionTree()`(forecast_info 기반)와 **소스가 다르다.**
 * 배송지 필터는 zip_code 를 조회해 우편번호 구간으로 바꾸므로, 시군구 명칭이 zip_code 와
 * 어긋나면 조회가 조용히 0건이 된다. 그래서 배송지 UI 는 반드시 이 트리를 써야 한다.
 */
export const getShippingRegionTree = async () => {
  const res = await fetchApi.get(API_URL.REGION_SHIPPING_TREE);
  return res.data;
};
